/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
import { contribuyenteToString, empresaToString } from 'utils/padronesToString';
import { InputSearchPro } from 'components/InputSearch';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { padronesEnum } from '../enums';

const fieldsInfo = {};

const tabs = [
  {
    title: 'Información General',
    fields: [
      'clave',
      'contribuyente',
      'empresa',
      'nombre_comercio',
      'mercado',
      'tipos_de_mercados',
      'zona',
      'local',
      'num_locales',
      'giros',
      'giro_principal',
      'mts_largo',
      'mts_ancho',
      'superficie_local',
      'dias_laborales',
      'num_dias',
      'plaza',
      'expediente_licencia',
      'fecha_expedicion',
      'observaciones',
    ],
  },
].filter((e) => e);

const configs = {
  clave: {
    formItemProps: {
      label: 'Clave',
    },
  },
  contribuyente: {
    advanced: true,
    control: InputSearchPro,
    advancedComponent: BusquedaAvanzadaPadrones,
    advancedComponentProps: { tipoDePadron: padronesEnum.CONTRIBUYENTE, allowAdd: false },
    advancedComponentName: 'BusquedaAvanzadaPadrones',
    label: 'Contribuyente',
    tooltip: 'Búsqueda por clave, correo electrónico, nombre completo del contribuyente',
    resultProps: {
      name: 'contribuyente',
      label: 'Contribuyente',
      render: (contribuyente) => contribuyenteToString(contribuyente),
      breakPoints: { md: 16 },
    },
    breakPoints: { md: 16 },
  },
  empresa: {
    advanced: true,
    control: InputSearchPro,
    advancedComponent: BusquedaAvanzadaPadrones,
    advancedComponentProps: { tipoDePadron: padronesEnum.EMPRESA, allowAdd: false },
    advancedComponentName: 'BusquedaAvanzadaPadrones',
    label: 'Empresa',
    tooltip: 'Búsqueda por Razón social',
    resultProps: {
      name: 'empresa',
      label: 'Empresa',
      render: (empresa) => empresaToString(empresa),
    },
  },
  giros: {
    formItemProps: {
      label: 'Giro de mercado',
      required: true,
    },
  },
  nombre_comercio: {
    formItemProps: {
      label: 'Nombre de Comercio',
    },
    required: true,
  },
  mercado: {
    formItemProps: {
      label: 'Mercado',
    },
    fkListIsPaginated: true,
    required: true,
  },
  tipos_de_mercados: {
    formItemProps: {
      label: 'Tipo de puesto',
    },
  },
  zona: {
    formItemProps: {
      label: 'Zona',
    },
  },
  local: {
    formItemProps: {
      label: 'Número de puesto',
    },
  },
  num_locales: {
    formItemProps: {
      label: 'Número de locales',
    },
  },
  giro_principal: {
    formItemProps: {
      label: 'Giro Principal',
    },
    required: true,
  },
  mts_largo: {
    formItemProps: {
      label: 'Metros de largo',
    },
  },
  mts_ancho: {
    formItemProps: {
      label: 'Metros de ancho',
    },
  },
  superficie_local: {
    formItemProps: {
      label: 'Superficie local',
    },
  },
  dias_laborales: {
    formItemProps: {
      label: 'Días laborales',
    },
  },
  num_dias: {
    formItemProps: {
      label: 'Número de días laborales',
    },
  },
  plaza: {
    formItemProps: {
      label: 'Plaza',
    },
  },
  expediente_licencia: {
    formItemProps: {
      label: 'Expediente de Licencia',
    },
  },
  fecha_expedicion: {
    formItemProps: {
      label: 'Fecha de expedición',
    },
  },
  observaciones: {
    formItemProps: {
      label: 'Observaciones',
    },
    colProps: { md: 16 },
    controlProps: {
      autoSize: { minRows: 3, maxRows: 3 },
    },
  },
};

const forbiddenProps = [];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
